import { connect } from 'react-redux';
import IAppState from "../../../IAppState";
import DownloadComponent from '../components/DownloadComponent';
import ActMain from '../../../act-main';
import IMainState from '../../../IMainState';
import { IDownloadProps, IDownloadPropsFunctions } from '../props/IDownloadProps';
import { ll_download_data_with_actions, ll_fetch } from '../../../tools';
import * as download from "downloadjs";


function downloadData(dispatch: any, jobId: string){
    ll_fetch(`/api/getZip?jobId=${jobId}`)
    .then(r => {
        if (!r.ok) {
            alert("Unable to download raw data.");
            return;
        }
        r.blob().then(data => {
            download(data, `data.zip`, r.headers.get('Content-Type'));
        })
    })
    .catch(err => {
        console.error(err);
    })

}

const mapStateToProps = ({ jobState, mainState}: IAppState): IDownloadProps => ({
    jobId: mainState.jobId
})

const mapDispatchToProps = (dispatch): IDownloadPropsFunctions => ({
    downloadData: (jobId: string) => downloadData(dispatch, jobId)
})


const DownloadContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadComponent)

export default DownloadContainer;
